import { API_V3_BASE_PATH, client } from 'src/apis/httpClient';
import UserModel from 'src/models/UserModel';
import { getVerisoulSessionId } from 'src/util/verisoul';

export type VerisoulSession = {
  decision: string;
  accountScore: number;
  lists: string[];
};

export const validateVerisoulSession = async (user: UserModel): Promise<VerisoulSession | null> => {
  try {
    const verisoulSessionId = await getVerisoulSessionId(user);

    if (!verisoulSessionId) return null;

    const { headers } = user.getApiV3ReqOpts();

    const url = `${API_V3_BASE_PATH}/verisoul/auth`;

    const { data } = await client.post(
      url,
      {
        sessionId: verisoulSessionId,
        email: user.signupData.email
      },
      { headers }
    );

    return data;
  } catch (error) {
    user.trackError('Error authenticating verisoul session', error);
    return null;
  }
};
